import * as React from "react";
import { ControlProps } from "react-select/src/components/Control";
import { TextField } from "@material-ui/core";
import { BaseTextFieldProps } from "@material-ui/core/TextField";
import { IOption } from "constants/types";

function inputComponent({
    inputRef,
    ...props
}: Pick<BaseTextFieldProps, "inputRef"> & React.HTMLAttributes<HTMLDivElement>) {
    return <div ref={inputRef} {...props} />;
}

export function Control(props: ControlProps<IOption>) {
    const {
        children,
        innerProps,
        innerRef,
        selectProps: { classes, TextFieldProps },
    } = props;
    return (
        <TextField
            className={classes.text}
            fullWidth={true}
            InputProps={{
                inputComponent,
                inputProps: {
                    className: classes.input,
                    ref: innerRef,
                    children,
                    ...innerProps,
                },
            }}
            {...TextFieldProps}
        />
    );
}
